export default __webpack_public_path__ + "static/media/volunteer2.28d5966a.jpeg";